"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodePathToTarget = void 0;
// hack to make getNodePathToTarget mockable by jest
// https://stackoverflow.com/questions/45102677/testing-recursive-calls-in-jest
var simpleNodeVisitor = require("./simple-node-visitor");
function getNodePathToTarget(nodeId, targetMatcher, map, knownPaths, visitedNodes) {
    if (knownPaths[nodeId] !== undefined) {
        // if we already know the path from the nodeId to the farther target point
        // let's use it and not walk through that path again
        return knownPaths[nodeId];
    }
    if (visitedNodes.has(nodeId)) {
        // this node was already visited but it's not in the knownPaths,
        // it's a dead-end (probably a loop) abort!!
        return null;
    }
    var node = map[nodeId];
    visitedNodes.add(nodeId);
    if (targetMatcher(node)) {
        return [nodeId];
    }
    var visitedChild = [];
    var longestPath = null;
    for (var i = 0; i < node.children.length; i++) {
        var childId = node.children[i];
        // avoid visiting the same child twice
        // it can happen when the same nodeId is used in more than one decision choice
        if (visitedChild.indexOf(childId) === -1) {
            visitedChild.push(childId);
            var path = simpleNodeVisitor.getNodePathToTarget(childId, targetMatcher, map, knownPaths, visitedNodes);
            knownPaths[childId] = path;
            if (path != null && path.length > (longestPath || []).length) {
                longestPath = path;
            }
        }
    }
    return longestPath != null ? __spreadArrays([nodeId], longestPath) : null;
}
exports.getNodePathToTarget = getNodePathToTarget;
